
/*
 * @Author: RYL
 * @Description: 封装配置对象，不同模式不同协议传的表单数据不一样，处理方法
 * @Date: 2020-12-11 11:44:12
 * @LastEditTime: 2022-03-31 16:41:13
 */
import { assign } from 'lodash'
export const setData = function (originalData, deviceSn, com) {
  let modeData = {
  }
  if (workModelMap[originalData.mode]) {
    modeData = workModelMap[originalData.mode](originalData, deviceSn, com)
  } else {
    modeData = workModelMap['UART'](originalData, deviceSn, com)
  }
  // modeData.offline_data = originalData.offline_data == '1'
  let protoData = {}
  if (originalData.mode == 'Local Server') {
    return assign({}, modeData, proto_lserver[originalData.proto](originalData, deviceSn, com))
  }
  if (originalData.proto) {
    try {
      protoData = {
        msg_dev_id: originalData.msg_dev_id ? originalData.msg_dev_id : '',
        did: originalData.did ? originalData.did : '',
        ...protoMap[originalData.proto](originalData, deviceSn, com),
      }
    } catch (err) {
      // 自定义协议
      protoData = {
        did: originalData.did ? originalData.did : '',
        msg_dev_id: originalData.msg_dev_id ? originalData.msg_dev_id : '',
      }
    }
  } else if (originalData.proto_mbtcp) {
    protoData = {
      ...ModbusTCP[originalData.proto_mbtcp](originalData, deviceSn, com),
    }
  } else if (originalData.proto_mbrtu) {
    protoData = {
      ...ModbusRTU[originalData.proto_mbrtu](originalData, deviceSn, com),
    }
  } else if (originalData.proto_mbascii) {
    protoData = {
      ...ModbusASCII[originalData.proto_mbascii](originalData, deviceSn, com),
    }
  }
  return assign({}, modeData, protoData)
}

// 工作模式表单数据
export const workModelMap = {
  'TCP Server': function (originalData) {
    return {
      ...tcp_udpServer(originalData),
      offline_data: originalData.offline_data == '1'
    }
  },
  'TCP Client': function (originalData) {
    return { ...tcp_udpClient(originalData), offline_data: originalData.offline_data == '1' }
  },
  'UDP Server': function (originalData) {
    return tcp_udpServer(originalData)
  },
  'UDP Client': function (originalData) {
    return tcp_udpClient(originalData)
  },
  'RealCom': function (originalData) {
    let data = {
      enabled: originalData.enabled == '1' || originalData.enabled === true ? true : false,
      name: originalData.name ? originalData.name : '',
      mode: originalData.mode,
      proto: originalData.proto ? originalData.proto : 'Pass-Through',
      enable_hbt: originalData.enable_hbt == '1' || originalData.enable_hbt === true ? true : false,
    }
    data = checkEnable_hbt(data, originalData)
    return data
  },
  'MQTT Client': function (originalData, deviceSn) {
    let data = {
      enabled: originalData.enabled == '1',
      name: originalData.name ? originalData.name : '',
      mode: originalData.mode,
      proto: originalData.proto ? originalData.proto : 'Pass-Through',
      enable_hbt: originalData.enable_hbt == '1',
      username: originalData.username ? originalData.username : '',
      password: originalData.password ? originalData.password : '',
      topic_sub: originalData.topic_sub ? originalData.topic_sub : '',
      topic_pub: originalData.topic_pub ? originalData.topic_pub : '',
      mqtt_qos: originalData.mqtt_qos ? originalData.mqtt_qos : '0',
      mqtt_cid: originalData.mqtt_cid ? originalData.mqtt_cid : deviceSn,
      mqtt_alive: originalData.mqtt_alive ? originalData.mqtt_alive : '',
      offline_data: originalData.offline_data == '1',
    }
    data = checkEnable_hbt(data, originalData)
    return data
  },
  'UART': function (originalData, deviceSn, com) {
    let data = {
      enabled: originalData.enabled == '1' || originalData.enabled === true ? true : false,
      name: originalData.name ? originalData.name : '',
      mode: 'UART',
      proto: originalData.proto ? originalData.proto === 'IEC' ? 'Pass-Through' : originalData.proto : 'Pass-Through',
      dev_name: originalData.dev_name ? originalData.dev_name : com[0].section,
    }
    return data
  },
  'Modbus TCP Master': function (originalData) {
    let data = {
      enabled: originalData.enabled == '1',
      name: originalData.name ? originalData.name : '',
      mode: originalData.mode,
      proto_mbtcp: 'Modbus TCP',
      slave_id: originalData.slave_id ? originalData.slave_id : 1,
      rsp_timeout: originalData.rsp_timeout ? originalData.rsp_timeout : '1500',
      modbus_debug: originalData.modbus_debug == 1
    }
    return data
  },
  'Modbus TCP Slave': function (originalData) {
    let data = {
      enabled: originalData.enabled == '1',
      name: originalData.name ? originalData.name : '',
      mode: originalData.mode,
      proto_mbtcp: 'Modbus TCP',
      slave_id: originalData.slave_id ? originalData.slave_id : 1,
      slave_port: originalData.slave_port ? originalData.slave_port : '30001',
      modbus_debug: originalData.modbus_debug == 1,
      sync_local_data: originalData.sync_local_data == 1,
    }
    return data
  },
  'Modbus RTU Master': function (originalData, deviceSn, com) {
    let data = {
      enabled: originalData.enabled == '1' || originalData.enabled === true ? true : false,
      name: originalData.name ? originalData.name : '',
      mode: originalData.mode,
      proto_mbrtu: 'Modbus RTU',
      slave_id: originalData.slave_id ? originalData.slave_id : 1,
      rsp_timeout: originalData.rsp_timeout ? originalData.rsp_timeout : '1500',
      byte_timeout: originalData.byte_timeout ? originalData.byte_timeout : '60',
      modbus_debug: originalData.modbus_debug == 1 || originalData.modbus_debug === true ? true : false,
      dev_name: originalData.dev_name ? originalData.dev_name : com[0].section,
      resend_times: originalData.resend_times
    }
    return data
  },
  'Modbus ASCII Master': function (originalData, deviceSn, com) {
    let data = {
      enabled: originalData.enabled == '1' || originalData.enabled === true ? true : false,
      name: originalData.name ? originalData.name : '',
      mode: originalData.mode,
      proto_mbascii: 'Modbus ASCII',
      slave_id: originalData.slave_id ? originalData.slave_id : 1,
      rsp_timeout: originalData.rsp_timeout ? originalData.rsp_timeout : '1500',
      byte_timeout: originalData.byte_timeout ? originalData.byte_timeout : '60',
      modbus_debug: originalData.modbus_debug == 1 || originalData.modbus_debug === true ? true : false,
      dev_name: originalData.dev_name ? originalData.dev_name : com[0].section,
      resend_times: originalData.resend_times
    }
    return data
  },
  'Modbus RTU Slave': function (originalData, deviceSn, com) {
    let data = {
      enabled: originalData.enabled == '1' || originalData.enabled === true ? true : false,
      name: originalData.name ? originalData.name : '',
      mode: originalData.mode,
      proto_mbrtu: 'Modbus RTU',
      slave_id: originalData.slave_id ? originalData.slave_id : 1,
      byte_timeout: originalData.byte_timeout ? originalData.byte_timeout : '60',
      modbus_debug: originalData.modbus_debug == 1 || originalData.modbus_debug === true ? true : false,
      dev_name: originalData.dev_name ? originalData.dev_name : com[0].section,
      sync_local_data: originalData.sync_local_data == 1,
      resend_times: originalData.resend_times
    }
    return data
  },
  'Modbus ASCII Slave': function (originalData, deviceSn, com) {
    let data = {
      enabled: originalData.enabled == '1' || originalData.enabled === true ? true : false,
      name: originalData.name ? originalData.name : '',
      mode: originalData.mode,
      proto_mbascii: 'Modbus ASCII',
      slave_id: originalData.slave_id ? originalData.slave_id : 1,
      byte_timeout: originalData.byte_timeout ? originalData.byte_timeout : '60',
      modbus_debug: originalData.modbus_debug == 1 || originalData.modbus_debug === true ? true : false,
      dev_name: originalData.dev_name ? originalData.dev_name : com[0].section,
      sync_local_data: originalData.sync_local_data == 1,
      resend_times: originalData.resend_times
    }
    return data
  },
  "Local Server": function (originalData, deviceSn, com) {
    let data = {
      enabled: originalData.enabled == '1' || originalData.enabled === true ? true : false,
      name: originalData.name ? originalData.name : '',
      mode: originalData.mode,
      proto: originalData.proto,
    }
    return data
  },
  "AIOT": function (originalData, deviceSn, com) {
    let data = {
      enabled: originalData.enabled == '1' || originalData.enabled === true ? true : false,
      name: originalData.name ? originalData.name : '',
      mode: originalData.mode,
      proto: originalData.proto,
      mqtt_qos: originalData.mqtt_qos ? originalData.mqtt_qos : '0',
      mqtt_alive: originalData.mqtt_alive ? originalData.mqtt_alive : '',
      instance_id: originalData.instance_id ? originalData.instance_id : '',
      product_key: originalData.product_key ? originalData.product_key : '',
      device_name: originalData.device_name ? originalData.device_name : '',
      device_secret: originalData.device_secret ? originalData.device_secret : '',
      upload_inter: originalData.upload_inter ? originalData.upload_inter : '',
      snmp_version: originalData.snmp_version ? originalData.snmp_version : '',
      snmp_group_name: originalData.snmp_group_name ? originalData.snmp_group_name : '',
      aiot_server: originalData.aiot_server ? originalData.aiot_server : '',
      security: originalData.security ? originalData.security == '1' ? true : false : false,
    }
    return data
  },
  "UDS Server": function (originalData, deviceSn, com) {
    let data = {
      enabled: originalData.enabled == '1' || originalData.enabled === true ? true : false,
      name: originalData.name ? originalData.name : '',
      mode: originalData.mode,
      proto: originalData.proto,
      uds_server_path: originalData.uds_server_path ? originalData.uds_server_path : '',
      // aiot_server: originalData.aiot_server ? originalData.aiot_server : '/tmp/smartnms.uds',
    }
    return data
  },
  "HTTP Client": function (originalData, deviceSn, com) {
    return {
      enabled: originalData.enabled == '1',
      mode: originalData.mode,
      name: originalData.name ? originalData.name : '',
      url: originalData.url,
      method: originalData.method ? originalData.method : 'POST',
      header: originalData.header,
      proto_http: 'HTTP',
      offline_data: originalData.offline_data == '1',
      custom_cmd: originalData.custom_cmd == 1,
      cmd_period: originalData.cmd_period ? originalData.cmd_period : '50',
      cmd_interval: originalData.cmd_interval ? originalData.cmd_interval : '60',
    }
  },
  "S7 Client": function (originalData) {
    return {
      enabled: originalData.enabled == '1',
      name: originalData.name || '',
      enable_hbt: originalData.enable_hbt == '1',
      s7_rack: originalData.s7_rack || '1',
      s7_slot: originalData.s7_rack || '1',
      daq_interval: originalData.daq_interval || '10',
      recv_timeout: originalData.recv_timeout || '100',
      mode: originalData.mode,
      hbt_interval: originalData.hbt_interval ? originalData.hbt_interval : '',
      hbt_data: originalData.hbt_data ? originalData.hbt_data : '',
      custom_cmd: originalData.custom_cmd == '1',
      cmd_period: originalData.cmd_period ? originalData.cmd_period : '50',
      cmd_interval: originalData.cmd_interval ? originalData.cmd_interval : '60',
      proto: originalData.proto
    }
  }
}

// 协议表单数据
export const protoMap = {
  'Pass-Through': function (originalData) {
    let data = {}
    return data
  },
  'Modbus JSON': function (originalData) {
    let data = {
      did: originalData.did ? originalData.did : '',
      interval: originalData.interval ? originalData.interval : '0',
      enable_daq: originalData.enable_daq,
      daq_interval: originalData.daq_interval ? originalData.daq_interval : '',
      cmd_interval: originalData.cmd_interval ? originalData.cmd_interval : '',
      cmd_period: originalData.cmd_period ? originalData.cmd_period : '50',
    }
    return data
  },
  'Custom Proto': function (originalData) {
    let data = {
      msg_prefix: originalData.msg_prefix ? originalData.msg_prefix : '',
      msg_len_size: originalData.msg_len_size ? originalData.msg_len_size : 0,
      msg_seq_size: originalData.msg_seq_size ? originalData.msg_seq_size : 0,
      msg_dev_id: originalData.did ? originalData.msg_dev_id : '',
      msg_crc_type: originalData.msg_crc_type ? originalData.msg_crc_type : 'NULL',
      msg_suffix: originalData.msg_suffix ? originalData.msg_suffix : '',
      msg_rep_conn: originalData.msg_rep_conn == '1'
    }
    return data
  },
  'Custom': function (originalData) {
    let data = {
      msg_prefix: originalData.msg_prefix ? originalData.msg_prefix : '',
      msg_len_size: originalData.msg_len_size ? originalData.msg_len_size : 0,
      msg_seq_size: originalData.msg_seq_size ? originalData.msg_seq_size : 0,
      msg_dev_id: originalData.did ? originalData.msg_dev_id : '',
      msg_crc_type: originalData.msg_crc_type ? originalData.msg_crc_type : 'NULL',
      msg_suffix: originalData.msg_suffix ? originalData.msg_suffix : '',
      msg_rep_conn: originalData.msg_rep_conn == '1',
      msg_upload_dev_id: originalData.msg_upload_dev_id == '1'
    }
    return data
  },
  '4G DTU': function (originalData) {
    let data = {
      dtu_svr_name: originalData.dtu_svr_name ? originalData.dtu_svr_name : '',
      dtu_id: originalData.dtu_id ? originalData.dtu_id : ''
    }
    return data
  },
  'SCTC OEM': function (originalData) {
    let data = {
      firm_code: originalData.firm_code ? originalData.firm_code : '',
      dev_type: originalData.dev_type ? originalData.dev_type : '',
      dev_key: originalData.dev_key ? originalData.dev_key : '',
      gps_lng: originalData.gps_lng ? originalData.gps_lng : '',
      gps_lat: originalData.gps_lat ? originalData.gps_lat : '',
      key_date: originalData.key_date ? originalData.key_date : '',
      dev_prefix: originalData.dev_prefix ? originalData.dev_prefix : ''
    }
    return data
  },
  'Modbus IOT': function (originalData) {
    let data = {}
    return data
  },
  "ChilinkIOT": function () {
    let data = {}
    return data
  },
  "IO Control": function () {
    let data = {
      auto_report: originalData.auto_report,
      report_condition: 'cycle',
      report_interval: '',
      did: originalData.did ? originalData.did : '',
    }
    return data
  },
  "ICP JSON": function () {
    return {
      did: originalData.did ? originalData.did : '',
      interval: originalData.interval ? originalData.interval : '0',
      enable_daq: originalData.enable_daq,
      daq_interval: originalData.daq_interval ? originalData.daq_interval : '',
      cmd_interval: originalData.cmd_interval ? originalData.cmd_interval : '',
      cmd_period: originalData.cmd_period ? originalData.cmd_period : '50',
      interval: originalData.interval ? originalData.interval : '0',
    }
  },
  "ChilinkIOT": function () {
    return {
      did: originalData.did ? originalData.did : '',
      interval: originalData.interval ? originalData.interval : '0',
      enable_daq: originalData.enable_daq,
      daq_interval: originalData.daq_interval ? originalData.daq_interval : '',
      cmd_interval: originalData.cmd_interval ? originalData.cmd_interval : '',
      cmd_period: originalData.cmd_period ? originalData.cmd_period : '50',
    }
  },
  'UTEPO': function () {
    let data = {}
    return data
  },
  'S7': function () {
    return {
      enabled: originalData.enabled == '1',
      name: originalData.name || '',
      enable_hbt: originalData.enable_hbt == '1',
      s7_rack: originalData.s7_rack || '1',
      s7_slot: originalData.s7_rack || '1',
      daq_interval: originalData.daq_interval || '10',
      recv_timeout: originalData.recv_timeout || '100',
      mode: originalData.mode,
      hbt_interval: originalData.hbt_interval ? originalData.hbt_interval : '',
      hbt_data: originalData.hbt_data ? originalData.hbt_data : '',
      custom_cmd: originalData.custom_cmd == '1',
      cmd_period: originalData.cmd_period ? originalData.cmd_period : '50',
      cmd_interval: originalData.cmd_interval ? originalData.cmd_interval : '60',
      proto: originalData.proto
    }
  }
}
export const checkEnable_hbt = function (data, originalData) {
  if (data.enable_hbt) {
    data.hbt_interval = originalData.hbt_interval ? originalData.hbt_interval : ''
    data.hbt_data = originalData.hbt_data ? originalData.hbt_data : ''
  } else {
    delete data.hbt_interval
    delete data.hbt_data
  }
  return data
}
// UDP Server && TCP Server一样
export const tcp_udpServer = function (originalData) {
  let data = {
    enabled: originalData.enabled == '1' || originalData.enabled === true ? true : false,
    name: originalData.name ? originalData.name : '',
    mode: originalData.mode,
    listen_port: originalData.listen_port ? originalData.listen_port : '30001',
    proto: originalData.proto ? originalData.proto : 'Pass-Through',
    enable_hbt: originalData.enable_hbt == '1' || originalData.enable_hbt === true ? true : false,
  }
  data = checkEnable_hbt(data, originalData)
  return data
}

// udp client和tcp client 一样
export const tcp_udpClient = function (originalData) {
  let data = {
    enabled: originalData.enabled == '1' || originalData.enabled === true ? true : false,
    name: originalData.name ? originalData.name : '',
    mode: originalData.mode,
    proto: originalData.proto ? originalData.proto : 'Pass-Through',
    enable_hbt: originalData.enable_hbt == '1' || originalData.enable_hbt === true ? true : false,
    local_port: originalData.local_port
  }
  data = checkEnable_hbt(data, originalData)
  return data
}

// proto_lserver
export const proto_lserver = {
  'BlockChain': function (originalData) {
    return {
      proto: originalData.proto,
    }
  },
  'DAQ': function (originalData) {
    return {
      proto: originalData.proto,
      sync_snmp_data: originalData.sync_snmp_data == '1',
    }
  },
  'IO Control': function (originalData) {
    return {
      proto: originalData.proto,
      sub_device_id: originalData.sub_device_id || '1',
    }
  }
}
export const ModbusRTU = {
  'Modbus RTU': function (originalData, deviceSn, com) {
    return {
      dev_name: originalData.dev_name ? originalData.dev_name : com[0].section,
      slave_id: originalData.slave_id ? originalData.slave_id : 1,
      byte_timeout: originalData.byte_timeout ? originalData.byte_timeout : '60',
      resend_times: originalData.resend_times,
      sync_local_data: originalData.sync_local_data == 1,
      modbus_debug: originalData.modbus_debug == 1,
      custom_cmd: originalData.custom_cmd == 1,
      rsp_timeout: originalData.rsp_timeout ? originalData.rsp_timeout : '1500',
      proto_mbrtu: originalData.proto_mbrtu,
      cmd_period: originalData.cmd_period ? originalData.cmd_period : '50',
      cmd_interval: originalData.cmd_interval ? originalData.cmd_interval : '60',
    }
  }
}
export const ModbusTCP = {
  'Modbus TCP': function (originalData, deviceSn, com) {
    return {
      proto_mbrtu: originalData.proto_mbtcp,
      slave_id: originalData.slave_id ? originalData.slave_id : 1,
      rsp_timeout: originalData.rsp_timeout ? originalData.rsp_timeout : '1500',
      modbus_debug: originalData.modbus_debug == 1,
      custom_cmd: originalData.custom_cmd == 1,
      cmd_period: originalData.cmd_period ? originalData.cmd_period : '50',
      cmd_interval: originalData.cmd_interval ? originalData.cmd_interval : '60',
      slave_port: originalData.slave_port ? originalData.slave_port : '30001',
    }
  }
}

export const ModbusASCII = {
  'Modbus ASCII': function (originalData, deviceSn, com) {
    return {
      proto_mbascii: originalData.proto_mbascii,
      dev_name: originalData.dev_name ? originalData.dev_name : com[0].section,
      slave_id: originalData.slave_id ? originalData.slave_id : 1,
      rsp_timeout: originalData.rsp_timeout ? originalData.rsp_timeout : '1500',
      byte_timeout: originalData.byte_timeout ? originalData.byte_timeout : '60',
      resend_times: originalData.resend_times,
      modbus_debug: originalData.modbus_debug == 1,
      custom_cmd: originalData.custom_cmd == 1,
      cmd_period: originalData.cmd_period ? originalData.cmd_period : '50',
      cmd_interval: originalData.cmd_interval ? originalData.cmd_interval : '60',
    }
  }
}